import React, { Component, useState, useRef } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Tabs, Modal, Input, Divider, Upload, Icon, Select, Button, message } from 'antd'
import styles from './productInfoDialog.module.scss'
import * as actions from '@/models/products/actions'
import * as apis from '@/apis'
import UploadFiles from './UploadFiles';
import MultipleVideoUpload from './MultipleVideoUpload';
import 'braft-editor/dist/index.css'
import BraftEditor from 'braft-editor'
import { UploadOutlined } from '@ant-design/icons';
const { Option } = Select;

const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 16 },
}
const tenantMode = process.env.APP_MODE === 'tenant'

@Form.create()
class CreateModal extends Component {
  state = {
    loading: false,
    categories: [],
    tab: 1,
    pdfs: this.props.product?.files || [],
  }
  fetch = async () => {
    this.setState({ loading: true })
    const result = await apis.findRecommend()
    let categories = result
    this.setState({
      categories,
      loading: false
    })
  }
  onUploadStart = file => {
    this.setState({ loading: true })
  }

  tabOnChange = key => {
    this.setState({
      tab: key
    })
  }

  customRequest = ({ file }) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('type', 'order-images') //product-cover

    apis.uploadFile(formData).then(response => {
      this.setState({ loading: false })

      this.props.form.setFieldsValue({
        cover: response.url + '?x-oss-process=image/resize,m_fill,h_460,w_460/format,jpg'
      })
    }).catch(err => {
      this.setState({ loading: false })

      message.error(err.message || '图片上传失败')
      console.error('onError', err)
    })

    return {
      abort() {
        console.log('upload progress is aborted.')
      },
    }
  }

  componentDidMount() {
    const { product } = this.props
    this.fetch()
    if (product && product.page) {
      this.props.form.setFieldsValue({
        page: BraftEditor.createEditorState(product.page)
      })
    }

    if (product && product.content) {
      this.props.form.setFieldsValue({
        content: BraftEditor.createEditorState(product.content)
      })
    }
  }

  handleSubmit = e => {
    const { dispatch, product, tenant_id, onSuccess, disabled, submit } = this.props
    e.preventDefault();

    if (disabled) {
      return false
    }
    // productCategory: values.productCategory
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }
      if (values.page) {
        values.page = values.page.toHTML()
      }

      if (values.content) {
        values.content = values.content.toHTML()
      }
      if (product && product._id) {
        apis.updateProduct(product._id, values, { tenant_id })
          .then(() => {
            message.success('更新成功')
            if (dispatch) {
              dispatch(actions.updated(product._id, values))
            }
            submit()
            onSuccess()
          })
          .catch(error => message.error(error.message || '更新失败'))
      } else {
        apis.createProduct(values, { tenant_id })
          .then(result => {
            message.success('添加成功')
            if (dispatch) {
              dispatch(actions.created(result))
            }
            submit()
            onSuccess()
          })
          .catch(error => message.error(error.message || '添加失败'))
      }
    });
  }
  uploadPDFRequest = (file) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('type', 'product-files')
    apis.uploadFile(formData).then(response => {
      //this.setState({ loading: false })
      const asset = {
        id: Math.random().toString(36).slice(-8),
        name: response.name,
        url: response.url,
        file: response._id,
        type: response.type,
        createdAt: new Date()
      }
      //let pdfs = this.props.form.getFieldValue('files');
      this.setState({
        pdfs: [...this.state.pdfs, asset]
      }
      )
      //onSuccess(response,asset)
    }).catch(err => {
      message.error(err.message || '文件上传失败')
      //onError(err)
    })
  }
  onPDFChange = ({ file, fileList }) => {
    if (file.status !== 'uploading') {
      this.setState({ pdfs: fileList })
    }
  }
  render() {
    const { product, disabled } = this.props
    const { getFieldDecorator, validateFields, getFieldValue, setFieldsValue } = this.props.form
    const categories = this.state.categories
    const editorProps = {
      controls: [
        'undo', 'redo', 'separator',
        'font-size', 'line-height', 'letter-spacing', 'separator',
        'text-color', 'bold', 'italic', 'underline', 'strike-through', 'separator',
        'superscript', 'subscript', 'remove-styles', 'separator', 'text-indent', 'text-align', 'separator',
        'headings', 'list-ul', 'list-ol', 'blockquote', 'separator',
        'link', 'separator', 'hr', 'separator',
        'clear'
      ],
      media: {
        // accepts: {
        //   image: 'image/png,image/jpeg,image/gif',
        //   video: false,
        //   audio: false
        // },
        // externals: {
        //   // embed: false
        // }
      }
    }
    // if(product?.files){
    //   this.setState({pdfs:product.files})
    // }
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">上传</div>
      </div>
    )

    if (disabled) {
      editorProps.controls = []
    }

    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <div className={styles.wrap}>
            <div className={styles.infoWrap}>
              <div className={styles.left}>
                <Form.Item  {...formItemLayout} label="产品分类" required>
                  {getFieldDecorator('category', {
                    initialValue: product?.category,
                    rules: [
                      {
                        required: true,
                        message: '请选择产品分类',
                      },
                    ],
                  })(
                    <Select mode="default" allowClear showArrow placeholder={`请选择产品分类`} >
                      {
                        categories.map(ele => {
                          return <Option key={ele._id} value={ele._id}>{ele.name}</Option>
                        })
                      }
                    </Select>
                  )}
                </Form.Item>
                <Form.Item
                  {...formItemLayout}
                  label="产品名称及型号"
                  disabled={disabled}
                  required>
                  {getFieldDecorator('name', {
                    initialValue: product && product.name,
                    rules: [
                      {
                        required: true,
                        message: '请输入产品名称及型号',
                      },
                    ],
                  })(
                    <Input disabled={disabled} autoFocus placeholder="请输入产品名称及型号" />
                  )}
                </Form.Item>
                <Form.Item
                  {...formItemLayout}
                  label="产品图片"
                  required>
                  {getFieldDecorator('cover', {
                    initialValue: product && product.cover,
                    rules: [
                      {
                        required: true,
                        message: '请上传产品封面',
                      },
                    ],
                  })(
                    <Upload
                      accept=".png, .jpg, .jpeg"
                      multiple={false}
                      name="avatar"
                      disabled={disabled}
                      listType="picture-card"
                      className="avatar-uploader"
                      showUploadList={false}
                      onStart={this.onUploadStart}
                      customRequest={this.customRequest}>
                      {getFieldValue('cover') ?
                        (
                          <img
                            src={getFieldValue('cover')}
                            width="80"
                            alt="avatar" />
                        ) :
                        uploadButton
                      }
                    </Upload>
                  )}
                </Form.Item>

                <Form.Item  {...formItemLayout}
                  label="产品资料"
                  extra="提交后客服将在24小时内处理，师傅可通过小程序＞产品资料中查看"
                >
                  {getFieldDecorator('content')(
                    <BraftEditor className={styles.editor} style={{ height: 100 }} controls={[]}></BraftEditor>
                  )}
                </Form.Item>

              </div>
              <Divider type="vertical" style={{ height: "600px" }}></Divider>

              <div className={styles.right}>
                <Form.Item
                  {...formItemLayout}
                  label="注意事项"
                  extra="产品相关的注意事项">
                  {getFieldDecorator('desc', {
                    initialValue: product && product.desc,
                    // rules: [
                    //   {
                    //     required: true,
                    //     message: '请填写注意事项',
                    //   },
                    // ],
                  })(
                    <Input.TextArea style={{ height: 80 }} disabled={disabled} placeholder="请输入注意事项" />
                  )}
                </Form.Item>
                <Form.Item
                  {...formItemLayout}
                  label="视频地址"
                  extra="视频名称将会在师傅端显示，请先修改好名称（仅限MP4,WAV格式），大小200M以内">
                  {getFieldDecorator('videoList', {
                    initialValue: product?.video?.split(',')?.map((v, i) => {
                      let videoName = product?.videoName
                      if (videoName) {
                        videoName = videoName?.split(',')
                      }
                      if (v) {
                        return {
                          response: {
                            id: Math.random().toString(36).slice(-8),
                            name: videoName[i] || '',
                            url: v
                          }
                        }
                      }
                    }).filter(v => v),
                    rules: [
                      {
                        required: false,
                        message: '请填写帮助视频播放地址，多个视频请换行填写',
                      },
                    ],
                  })(
                    <MultipleVideoUpload onFileChange={(list) => {
                      const videoUrl = list.map(v => v?.response?.url || '')
                      const videoName = list.map(v => v?.response?.name || '')
                      setFieldsValue({
                        video: videoUrl.join(','),
                        videoName: videoName.join(','),
                      })
                    }} />
                  )}
                </Form.Item>
                <Form.Item
                  style={{ display: 'none' }}
                  {...formItemLayout}
                  label="视频地址">
                  {getFieldDecorator('video', {
                    initialValue: product && product.video,
                    rules: [
                      {
                        required: false,
                        message: '请填写帮助视频播放地址，多个视频请换行填写',
                      },
                    ],
                  })(
                    <Input.TextArea style={{ height: 120 }} disabled={disabled} placeholder="请填写帮助视频播放地址，多个视频请换行填写" />
                  )}
                </Form.Item>
                <Form.Item
                  style={{ display: 'none' }}
                  {...formItemLayout}
                  label="视频名称"
                  extra="产品相关视频名称">
                  {getFieldDecorator('videoName', {
                    initialValue: product && product.videoName,
                    rules: [
                      {
                        message: '请填写视频名称，多个视频请用空格分割',
                      },
                    ],
                  })(
                    <Input.TextArea disabled={disabled} placeholder="请填写视频名称，多个视频请用空格分割" style={{ height: 120 }} />
                  )}
                </Form.Item>
                <Form.Item {...formItemLayout}
                  label="帮助文档"> {
                    getFieldDecorator('files', {
                      initialValue: product?.files,
                      rules: [
                        {
                          required: false,
                          message: '请上传帮助文档',
                        },
                      ],
                    })(
                      <UploadFiles disabled={disabled}>
                      </UploadFiles>
                    )}
                </Form.Item>
              </div>

            </div>
            {/* {tenantMode && (
              <div style={{ display: 'flex' }}>
                <div style={{ flexGrow: 1, flexBasis: '50%' }}>
                  <div>相关安装/维修视频网址链接 {!tenantMode && ' (仅限商家端编辑)'}</div>
                  {getFieldDecorator('content')(
                    <BraftEditor
                      {...editorProps}
                      controls={(!tenantMode || disabled) ? [] : editorProps.controls}
                      readOnly={!tenantMode || disabled}
                      className={styles.editor}
                      placeholder="请输入正文内容"
                    />
                  )}
                </div>
              </div>)
            } */}
          </div>
          {
            !disabled && (
              <div className={styles.footer}>
                <Button type="primary" htmlType="submit">
                  保存
                </Button>
              </div>
            )
          }
        </Form>
      </div>
    )
  }
}

const TenantInfoDialog = ({
  modal: {
    name,
  },
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => {
  return (
    <Modal
      title={ownProps.title}
      destroyOnClose
      footer={null}
      width={1200}
      visible={isOpen}
      onCancel={hide}>
      <CreateModal submit={submit} {...ownProps} />
    </Modal>
  )
}

export default sagaModal({
  name: 'PRODUCT_INFO_DIALOG',
})(TenantInfoDialog)
